import styled from 'styled-components'
import { BodyDefault, VerySmall } from '../typography/styled'
import SVG from "react-inlinesvg";
type ActiveProp = {
  active?:boolean;
  error?:boolean;
  containerCustom?:any;
  customStyles?:any;
  $hasIcon?:boolean;
}
export const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'containerCustom',
})<ActiveProp>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${({containerCustom}) =>containerCustom}

  @media (max-width: 768px) {
    width: 100%;
    min-width: 0;
    max-width: 100%;
  }
`

export const ToolTipImg = styled.img`
  margin-left:'4px';
  &:hover{
    cursor: pointer;
  }
`

export const PrefixText = styled.p`
  color:${({theme}) => theme.grey[600]};
  font-size: 15px;
  line-height: 20px;
  margin:0px;
  padding:0px;
`
export const StyledInput = styled.input.withConfig({
  shouldForwardProp: (prop) => prop !== 'error' && prop !== 'customStyles',
})<ActiveProp>`
  appearance: none;
  -moz-appearance: textfield; /* Firefox */
  box-sizing: border-box;
  width: 100%;
  height: 40px;
  padding: 12px 10px;
  margin-top: 4px;
  font-weight: 400;
  padding-right: 40px;
  padding-left: ${({$hasIcon}) => $hasIcon ? '34px' : '10px'};
  font-size: 15px;
  line-height: 20px;
  outline: none;
  background-color: ${({theme}) => theme.palette[10]};
  border:${({theme, error}) => error ? `1px solid ${theme.errors[600]}` :`1px solid ${theme.grey[350]}`};
  color:${({theme}) => theme.palette[900]};
  font-family:Inter;
  border-radius:${({theme}) => theme.radius.control};

  &[type='number'] {
    appearance: auto;
    -webkit-appearance: auto;
    -moz-appearance: auto;
    padding-right: 10px;
  }
  ${({customStyles}) => customStyles};

  @media (max-width: 768px) {
    width: 100%;
    min-width: 0;
    max-width: 100%;
  }
  &:focus{
    border: ${({theme, error}) => error ? `1px solid ${theme.errors[600]}` : `1px solid ${theme.accent[100]}`};
    box-shadow: ${({theme, error}) => error ? theme.isDark ? theme.shadows.errorFocusDark : theme.shadows.errorFocus : theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
  &::placeholder{
    color:${({theme}) => theme.grey[600]};
  }
  &:read-only{
    color:${({theme}) => theme.grey[700]};
    background-color: ${({theme}) => theme.palette[200]};
    border-color: ${({theme, error}) => error ? theme.errors[600] : theme.grey[350]};
    box-shadow: none;
    cursor: default;
  }
  &:disabled{
    cursor: not-allowed;
  }
  &:-webkit-autofill:focus {
    -webkit-text-fill-color: ${({theme}) => theme.palette[900]};
  }
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: ${({theme}) => theme.palette[900]};
      /* -webkit-text-fill-color: #fff !important; */
  }
`
export const StyledTextArea = styled.textarea.withConfig({
  shouldForwardProp: (prop) => prop !== 'error' && prop !== 'customStyles',
})<ActiveProp>`
  box-sizing: border-box;
  width: 100%;
  /* height: 40px; */
  min-height: 50px;
  max-height: 450px;
  padding: 12px 10px;
  margin-top: 4px;
  font-weight: 400;
  padding-right: 40px;
  padding-left: ${({$hasIcon}) => $hasIcon ? '34px' : '10px'};
  font-size: 15px;
  line-height: 20px;
  outline: none;
  background-color: ${({theme}) => theme.palette[10]};
  border:${({theme, error}) => error ? `1px solid ${theme.errors[600]}` :`1px solid ${theme.grey[350]}`};
  color:${({theme}) => theme.palette[900]};
  font-family:Inter;
  border-radius:${({theme}) => theme.radius.control};
  /* transition: 3s height ease-in-out; */
  ${({customStyles}) => customStyles}

  @media (max-width: 768px) {
    width: 100%;
    min-width: 0;
    max-width: 100%;
  }
  &:focus{
    border: ${({theme, error}) => error ? `1px solid ${theme.errors[600]}` : `1px solid ${theme.accent[100]}`};
    box-shadow: ${({theme, error}) => error ? theme.isDark ? theme.shadows.errorFocusDark : theme.shadows.errorFocus : theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
  &::placeholder{
    color:${({theme}) => theme.grey[600]};
  }
  &:read-only{
    color:${({theme}) => theme.grey[700]};
    background-color: ${({theme}) => theme.palette[200]};
    border-color: ${({theme, error}) => error ? theme.errors[600] : theme.grey[350]};
    box-shadow: none;
    cursor: default;
  }
  &:disabled{
    color:${({theme}) => theme.grey[700]};
    background-color: ${({theme}) => theme.palette[200]};
    border-color: ${({theme, error}) => error ? theme.errors[600] : theme.grey[350]};
    box-shadow: none;
    cursor: not-allowed;
  }
`

export const ErrorText = styled(BodyDefault)`
  color:${({theme}) => theme.errors[600]};
  margin-top: 6px;
  &:first-letter {
    text-transform: uppercase;
  }
`
export const Eye = styled.div`
  display: flex;
  position: absolute;
  top:33.5px;
  right:10px;
`

export const IconInput = styled.div`
  display: flex;
  position: absolute;
  top:33.5px;
  left:10px;
  pointer-events: none;
  img {
    width: 16px;
    height: 16px;
  }
`

export const PropContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  padding: 3px 4px;
  height:21px;
  background-color: ${({theme}) => theme.palette[300]};
  border-radius: ${({theme}) => theme.radius.xs};
  align-items: center;
`
export const Prop = styled(VerySmall)`
  color:${({theme}) => theme.palette[850]};
`


export const DeleteTag = styled(SVG)`
  width: 16px;
  height: 16px;
  margin-left:2px;
  margin-top:2px;
  & path {
    stroke:${({theme}) => theme.palette[800]};
  };
  &:hover{
    cursor: pointer;
    & path {
    stroke:${({theme}) =>theme.palette[800]};
  };
  }
`
